import { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

function RpFiltersSlidePanel(props) {
    return (
        <Box
            sx={{
                position: 'absolute',
                left: props.slidePaneOpen ? 0 : '100%',
                transition: 'left 0.5s ease',
                top: 0,
                height: '100%',
                width: '100%',
                p: 2,
            }}
        >
            {props.slidePanelSlot
                ? cloneElement(props.slidePanelSlot, { onSlidePanelClose: props.onSlidePanelClose })
                : null}
        </Box>
    );
}

RpFiltersSlidePanel.propTypes = {
    slidePaneOpen: PropTypes.bool.isRequired,
    slidePanelSlot: PropTypes.element,
    onSlidePanelClose: PropTypes.func,
};

export default RpFiltersSlidePanel;
